<template>
  <div class="container">
    <div class="row">
      <!-- <div class="col-lg-4 d-none .d-md-none d-lg-block align-self-center">
        <div style="float:right;text-align: right;" class="col-8">
           <div class="row align-items-center">
            <span style="display: inline-block; vertical-align: middle;padding:5px">Follow Us On:</span>
            <a href="https://www.facebook.com/amcredit" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon1.png"
                alt="facebook"
              />
            </a>
            <a href="https://www.twitter.com" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon2.png"
                alt="twitter"
              />
            </a>
            <a href="https://americancredit.business.site/" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon3.png"
                alt="business site"
              />
            </a>
            <a href="https://www.linkedin.com/company/amcredit" target="_blank">
              <img
                style="display: inline-block; vertical-align: middle;"
                src="../../assets/imgs/smallIcon4.png"
                alt="linkedin"
              />
            </a>
          </div>
        </div>
      </div> -->
      <div class="col-lg-12 col-sm-12">
        <div class="step-form__main pt-3">
          <!-- <div class="row">
            <div class="col-lg-3 col-sm-12">
              <span>Business Information</span>
            </div>
            <div class="col-lg-3 col-sm-12">
              <span>Personal Information</span>
            </div>
            <div class="col-lg-3 col-sm-12">
              <span class="step-text-active">Financial Review</span>
            </div>
            <div class="col-lg-3 col-sm-12">
              <span>
                <a href="tel:855-904-0188">
                  <i aria-hidden="true" class="phone-icon fa fa-phone"></i>
                  855-904-0188
                </a>
              </span>
            </div>
          </div> -->
          <!-- <hr /> -->

          <!-- <div v-if="frontAppliedProductId == 10000057823975"> -->
          <div v-if="this.$route.query.type == 'equipment'">
          <el-row :gutter="0">
            <el-col :span="16">
              <el-form class="step-form__form" :model="uploadForm" ref="uploadForm">

                <el-row>
                    <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px;">Equipment information</h3>
                </el-row>
              
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Vendor name" prop="vendorName">
                      <el-input type="text" placeholder="Vendor name" v-model="uploadForm.vendorName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Phone" prop="vendorPhone">
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder
                        :maxlength="10"
                        v-model="uploadForm.vendorPhone"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Vendor address" prop="vendorAddress">
                  <el-input type="text" :maxlength="40" v-model="uploadForm.vendorAddress"></el-input>
                </el-form-item>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="City" prop="vendorCity">
                      <el-input type="text" :maxlength="30" v-model="uploadForm.vendorCity"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item
                      label="State"
                      prop="vendorState"
                      class="step-form__form-item--with-unit"
                    >
                      <el-select v-model="uploadForm.vendorState" placeholder="Select state">
                        <el-option
                          v-for="item in stateS"
                          :key="item.text"
                          :label="item.text"
                          :value="item.text"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="8" :lg="8">
                    <el-form-item label="Zip code" prop="vendorZipCode">
                      <el-input
                        type="tel"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        placeholder="5-digit postal code"
                        :maxlength="5"
                        v-model="uploadForm.vendorZipCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="Equipment amount" prop="equipmentAmount">
                      <el-input
                        type="number"
                        v-model="uploadForm.equipmentAmount"
                        onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                        :maxlength="8"
                        :min="0"
                      >
                        <template slot="prepend">$</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item
                      label="Equipment status"
                      prop="equipmentStatus"
                      class="step-form__form-item--with-unit"
                    >
                      <el-select v-model="uploadForm.equipmentStatus" placeholder="Equipment status">
                        <el-option
                          v-for="item in status"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item
                      label="Down Payment?"
                      prop="wantDownPayment"
                      class="step-form__form-item--with-unit"
                    >
                      <el-select v-model="uploadForm.wantDownPayment" placeholder="Do you want to pay a down payment?">
                        <el-option
                          v-for="item in downPaymentOrNot"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item
                      label="Reason for equipment purchase"
                      prop="reasonForEquipment"
                      class="step-form__form-item--with-unit"
                    >
                      <el-select v-model="uploadForm.reasonForEquipment" placeholder="Reason for equipment purchase">
                        <el-option
                          v-for="item in reasonsForEquipment"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item
                      label="Equipment type"
                      prop="equipmentType"
                      class="step-form__form-item--with-unit"
                    >
                      <el-select v-model="uploadForm.equipmentType" placeholder="What kind of equipment are you financing?">
                        <el-option
                          v-for="item in equipmentTypes"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="Equipment description" class="margin-bottom-0">
                  <el-input type="textarea" v-model="uploadForm.equipmentDesc" :rows=3></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <br>
          <br>

          <!-- <el-row>
              <h3 style="text-align: left; background: #006499; color: white; margin-left:10%; width: 80%; padding-left: 5px;">Bank statements</h3>
          </el-row>

              <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 12px;line-height: 24px;text-align: center;" class="step-form__title">
                Please attach last six months’ business bank statements (typically 1st page only with activity summary sections required)</h3>
          <div v-if="!dialogVisible">
            <el-upload
              
              class="avatar-uploader"
              action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
              :data="{tokenId: this.userInfo.token}"
              accept="*.*"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :on-progress="openFullScreen"
            >
              <i class="el-icon-plus avatar-uploader-icon">
                <span style="margin-left: 10px;">Choose File</span>
              </i>
            </el-upload>
          </div>
          <div id="uploaded" class="step-form__title">
          </div>

          <el-dialog v-model="dialogVisible" size="tiny">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>

          <el-row>
              <h3 style="text-align: left; background: #006499; color: white; margin-left:10%; width: 80%; padding-left: 5px;">Equipment invoices/titles</h3>
          </el-row>

              <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 12px;line-height: 24px;text-align: center;" class="step-form__title">
                Please attach a copy of recent monthly payment statement(s) for any term loan or equipment leases</h3>
          <div v-if="!dialogVisible2">
            <el-upload
              
              class="avatar-uploader"
              action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
              :data="{tokenId: this.userInfo.token}"
              accept="*.*"
              :show-file-list="false"
              :on-success="handleAvatarSuccess2"
              :before-upload="beforeAvatarUpload"
              :on-progress="openFullScreen"
            >
              <i class="el-icon-plus avatar-uploader-icon">
                <span style="margin-left: 10px;">Choose File</span>
              </i>
            </el-upload>
          </div>
          <div id="uploaded2" class="step-form__title">
          </div>

          <el-dialog v-model="dialogVisible2" size="tiny">
            <img width="100%" :src="dialogImageUrl2" alt />
          </el-dialog> -->

          </div>
          <!-- <div v-else-if="frontAppliedProductId == 10000057880003"> -->
          <div v-if="this.$route.query.type == 'billing'">
            <el-row :gutter="0">
              <el-col :span="16">
                <el-form class="step-form__form" :model="uploadForm" ref="uploadForm">

                  <el-row>
                    <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px;">Billing information</h3>
                  </el-row>
                
                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Average monthly billing" prop="averageMonthlyBilling">
                        <el-input type="number" v-model="uploadForm.averageMonthlyBilling" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Desired factoring amount" prop="desiredFactoringAmount">
                        <el-input type="number" v-model="uploadForm.desiredFactoringAmount" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Average invoice size" prop="averageInvoiceSize">
                        <el-input type="number" v-model="uploadForm.averageInvoiceSize" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Largest invoice" prop="largestInvoice">
                        <el-input type="number" v-model="uploadForm.largestInvoice" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Smallest invoice" prop="smallestInvoice">
                        <el-input type="number" v-model="uploadForm.smallestInvoice" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Do you bill in progress stages?" prop="anyBillInProgress">
                        <el-radio-group v-model="uploadForm.anyBillInProgress">
                          <el-radio :label="true">Yes</el-radio>
                          <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Are any sales bill and hold?" prop="anySalesBillHold">
                        <el-radio-group v-model="uploadForm.anySalesBillHold">
                          <el-radio :label="true">Yes</el-radio>
                          <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px;">Customer information</h3>
                  </el-row>
                  <el-row>
                    <h4 style="text-align: left; color: #33475b; padding-left: 5px;">Customer#1</h4>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Legal business name" prop="customerBusinessName1">
                        <el-input type="text" v-model="uploadForm.customerBusinessName1"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Email" prop="customerEmail1">
                        <el-input type="text" v-model="uploadForm.customerEmail1"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="Address" prop="customerAddress1">
                    <el-input type="text" v-model="uploadForm.customerAddress1"></el-input>
                  </el-form-item>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Phone" prop="customerPhone1">
                        <el-input type="tel" v-model="uploadForm.customerPhone1" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Fax" prop="customerFax1">
                        <el-input type="tel" v-model="uploadForm.customerFax1" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Website" prop="customerWebsite1">
                        <el-input type="text" v-model="uploadForm.customerWebsite1"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Payment terms" prop="customerPaymentTerms1">
                        <el-input type="text" v-model="uploadForm.customerPaymentTerms1"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Current balance" prop="customerCurrentBalance1">
                        <el-input type="number" v-model="uploadForm.customerCurrentBalance1" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <h4 style="text-align: left; color: #33475b; padding-left: 5px;">Customer#2</h4>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Legal business name" prop="customerBusinessName2">
                        <el-input type="text" v-model="uploadForm.customerBusinessName2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Email" prop="customerEmail2">
                        <el-input type="text" v-model="uploadForm.customerEmail2"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="Address" prop="customerAddress2">
                    <el-input type="text" v-model="uploadForm.customerAddress2"></el-input>
                  </el-form-item>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Phone" prop="customerPhone2">
                        <el-input type="tel" v-model="uploadForm.customerPhone2" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Fax" prop="customerFax2">
                        <el-input type="tel" v-model="uploadForm.customerFax2" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Website" prop="customerWebsite2">
                        <el-input type="text" v-model="uploadForm.customerWebsite2"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Payment terms" prop="customerPaymentTerms2">
                        <el-input type="text" v-model="uploadForm.customerPaymentTerms2"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Current balance" prop="customerCurrentBalance2">
                        <el-input type="number" v-model="uploadForm.customerCurrentBalance2" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <h4 style="text-align: left; color: #33475b; padding-left: 5px;">Customer#3</h4>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Legal business name" prop="customerBusinessName3">
                        <el-input type="text" v-model="uploadForm.customerBusinessName3"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Email" prop="customerEmail3">
                        <el-input type="text" v-model="uploadForm.customerEmail3"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="Address" prop="customerAddress3">
                    <el-input type="text" v-model="uploadForm.customerAddress3"></el-input>
                  </el-form-item>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Phone" prop="customerPhone3">
                        <el-input type="tel" v-model="uploadForm.customerPhone3" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Fax" prop="customerFax3">
                        <el-input type="tel" v-model="uploadForm.customerFax3" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Website" prop="customerWebsite3">
                        <el-input type="text" v-model="uploadForm.customerWebsite3"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Payment terms" prop="customerPaymentTerms3">
                        <el-input type="text" v-model="uploadForm.customerPaymentTerms3"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Current balance" prop="customerCurrentBalance3">
                        <el-input type="number" v-model="uploadForm.customerCurrentBalance3" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <h4 style="text-align: left; color: #33475b; padding-left: 5px;">Customer#4</h4>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Legal business name" prop="customerBusinessName4">
                        <el-input type="text" v-model="uploadForm.customerBusinessName4"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Email" prop="customerEmail4">
                        <el-input type="text" v-model="uploadForm.customerEmail4"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="Address" prop="customerAddress4">
                    <el-input type="text" v-model="uploadForm.customerAddress4"></el-input>
                  </el-form-item>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Phone" prop="customerPhone4">
                        <el-input type="tel" v-model="uploadForm.customerPhone4" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Fax" prop="customerFax4">
                        <el-input type="tel" v-model="uploadForm.customerFax4" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Website" prop="customerWebsite4">
                        <el-input type="text" v-model="uploadForm.customerWebsite4"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Payment terms" prop="customerPaymentTerms4">
                        <el-input type="text" v-model="uploadForm.customerPaymentTerms4"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Current balance" prop="customerCurrentBalance4">
                        <el-input type="number" v-model="uploadForm.customerCurrentBalance4" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <h4 style="text-align: left; color: #33475b; padding-left: 5px;">Customer#5</h4>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Legal business name" prop="customerBusinessName5">
                        <el-input type="text" v-model="uploadForm.customerBusinessName5"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Email" prop="customerEmail5">
                        <el-input type="text" v-model="uploadForm.customerEmail5"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="Address" prop="customerAddress5">
                    <el-input type="text" v-model="uploadForm.customerAddress5"></el-input>
                  </el-form-item>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Phone" prop="customerPhone5">
                        <el-input type="tel" v-model="uploadForm.customerPhone5" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Fax" prop="customerFax5">
                        <el-input type="tel" v-model="uploadForm.customerFax5" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Website" prop="customerWebsite5">
                        <el-input type="text" v-model="uploadForm.customerWebsite5"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Payment terms" prop="customerPaymentTerms5">
                        <el-input type="text" v-model="uploadForm.customerPaymentTerms5"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Current balance" prop="customerCurrentBalance5">
                        <el-input type="number" v-model="uploadForm.customerCurrentBalance5" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Do you have any outstanding loans/advances?" prop="anyOutstandingLoans">
                        <el-radio-group v-model="uploadForm.anyOutstandingLoans">
                          <el-radio :label="true">Yes</el-radio>
                          <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Is your inventory/receivables pledged as collateral?" prop="ifReceivablesAsCollateral">
                        <el-radio-group v-model="uploadForm.ifReceivablesAsCollateral">
                          <el-radio :label="true">Yes</el-radio>
                          <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Name of financial institution" prop="nameOfFinancialInstitution">
                        <el-input type="text" v-model="uploadForm.nameOfFinancialInstitution"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Loan amount and terms" prop="loanAmountAndTerms">
                        <el-input type="text" v-model="uploadForm.loanAmountAndTerms"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Are your federal, state, & payroll taxes current?" prop="ifCurrentTaxesPaid">
                        <el-radio-group v-model="uploadForm.ifCurrentTaxesPaid">
                          <el-radio :label="true">Yes</el-radio>
                          <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="If No: Federal taxes owed?" prop="federalTaxesOwed">
                        <el-input type="number" v-model="uploadForm.federalTaxesOwed" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="State taxes owed?" prop="stateTaxesOwed">
                        <el-input type="number" v-model="uploadForm.stateTaxesOwed" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Any liens been placed?" prop="anyLiensPlaced">
                        <el-radio-group v-model="uploadForm.anyLiensPlaced">
                          <el-radio :label="true">Yes</el-radio>
                          <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Are you on a payment plan?" prop="anyPaymentPlan">
                        <el-radio-group v-model="uploadForm.anyPaymentPlan">
                          <el-radio :label="true">Yes</el-radio>
                          <el-radio :label="false">No</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="8" :lg="8">
                      <el-form-item label="Monthly payment" prop="monthlyPayment">
                        <el-input type="number" v-model="uploadForm.monthlyPayment" onkeypress="return event.keyCode>=48&&event.keyCode<=57"
                          :maxlength="8"
                          :min="0"
                        >
                          <template slot="prepend">$</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <h3 style="text-align: left; background: #006499; color: white; padding-left: 5px;">Legal information</h3>
                  </el-row>

                  <el-form-item label="Is the company or any officer involved in any type of litigation or lawsuit?" prop="anyLawsuit">
                    <el-radio-group v-model="uploadForm.anyLawsuit">
                      <el-radio :label="true">Yes</el-radio>
                      <el-radio :label="false">No</el-radio>
                    </el-radio-group>
                  </el-form-item>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Company attorney" prop="companyAttorney">
                        <el-input type="text" v-model="uploadForm.companyAttorney"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Attorney phone" prop="companyAttorneyPhone">
                        <el-input type="tel" v-model="uploadForm.companyAttorneyPhone" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Company accountant" prop="companyAccountant">
                        <el-input type="text" v-model="uploadForm.companyAccountant"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                      <el-form-item label="Accountant phone" prop="companyAccountantPhone">
                        <el-input type="tel" v-model="uploadForm.companyAccountantPhone" onkeypress="return event.keyCode>=48&&event.keyCode<=57" :maxlength="10"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                </el-form>
              </el-col>
            </el-row>

            <!-- <el-row>
              <h3 style="text-align: left; background: #006499; color: white; margin-left:10%; width: 80%; padding-left: 5px;">Supporting documents</h3>
            </el-row>

                <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 12px;line-height: 24px;text-align: center;" class="step-form__title">
                  Please attach last six months’ business bank statements (typically 1st page only with activity summary sections required)</h3>
            <div v-if="!dialogVisible">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded" class="step-form__title">
            </div>

            <el-dialog v-model="dialogVisible" size="tiny">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>

            <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 12px;line-height: 24px;text-align: center;" class="step-form__title">
              Detailed accounts payable aging</h3>
            <div v-if="!dialogVisible3">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess3"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded3" class="step-form__title">
            </div>

            <el-dialog v-model="dialogVisible3" size="tiny">
              <img width="100%" :src="dialogImageUrl3" alt />
            </el-dialog>

            <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 12px;line-height: 24px;text-align: center;" class="step-form__title">
              Articles of incorporation & operating agreement</h3>
            <div v-if="!dialogVisible4">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess4"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded4" class="step-form__title">
            </div>

            <el-dialog v-model="dialogVisible4" size="tiny">
              <img width="100%" :src="dialogImageUrl4" alt />
            </el-dialog>

            <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 12px;line-height: 24px;text-align: center;" class="step-form__title">
              Customer contracts and/or purchase orders</h3>
            <div v-if="!dialogVisible5">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess5"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded5" class="step-form__title">
            </div>

            <el-dialog v-model="dialogVisible5" size="tiny">
              <img width="100%" :src="dialogImageUrl5" alt />
            </el-dialog>

            <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 12px;line-height: 24px;text-align: center;" class="step-form__title">
              Detailed accounts receivable aging</h3>
            <div v-if="!dialogVisible6">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess6"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded6" class="step-form__title">
            </div>

            <el-dialog v-model="dialogVisible6" size="tiny">
              <img width="100%" :src="dialogImageUrl6" alt />
            </el-dialog>

            <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 12px;line-height: 24px;text-align: center;" class="step-form__title">
              Sample invoice with backup documentation (e.g. proof of delivery, inspection, time sheets, or performance proof)</h3>
            <div v-if="!dialogVisible7">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess7"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded7" class="step-form__title">
            </div>

            <el-dialog v-model="dialogVisible7" size="tiny">
              <img width="100%" :src="dialogImageUrl7" alt />
            </el-dialog> -->
          </div>

          <div v-if="this.$route.query.type == 'paycheck'">

            <el-row>
              <h3 style="text-align: left; background: #006499; color: white; margin-left:10%; width: 80%; padding-left: 5px;">PPP REQUIRED DOCUMENTS</h3>
            </el-row>

            <h3 style="padding-bottom: 10px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 24px;line-height: 24px;text-align: center;" class="step-form__title">
              1. PPP Borrower Application Form (revised 1.8.2021)-508</h3>
            <p style="text-align: center;"><a href="../../../static/PPP Borrower Application Form (revised 1.8.2021)-508.pdf" target="blank">Click here to download 【PPP Borrower Application Form (revised 1.8.2021)-508】</a></p>
            <div v-if="!dialogVisible">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess8"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded8" class="step-form__title">
            </div>

            <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 24px;line-height: 24px;text-align: center;" class="step-form__title">
              2. Driver’s License / Photo ID</h3>
            <div v-if="!dialogVisible">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess9"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded9" class="step-form__title">
            </div>

            <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 24px;line-height: 24px;text-align: center;" class="step-form__title">
              3. Voided Check</h3>
            <div v-if="!dialogVisible3">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess10"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded10" class="step-form__title">
            </div>

            <h3 style="padding-bottom: 10px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 24px;line-height: 24px;text-align: center;" class="step-form__title">
              4. Bank Statements</h3>
            <p style="text-align: center;">Please provide a bank statement that covers 2/15/2020 as proof that the Applicant was in business as of 2/15/2020. If available, bank statements that are downloaded from your bank’s website will work better than scanned versions.</p>
            <div v-if="!dialogVisible4">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess11"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded11" class="step-form__title">
            </div>

            <h3 style="padding-bottom: 10px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 24px;line-height: 24px;text-align: center;" class="step-form__title">
              5. Form 1120 or 1120-S</h3>
            <p style="text-align: center;">To substantiate health insurance (line 24 of 1120 or line 18 of 1120-S) or retirement benefits (line 23 of 1120 or line 17 of 1120-S) to employees.</p>
            <div v-if="!dialogVisible5">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess12"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded12" class="step-form__title">
            </div>

            <h3 style="padding-bottom: 10px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 24px;line-height: 24px;text-align: center;" class="step-form__title">
              6. Proof of Payroll Form 940</h3>
            <p style="text-align: center; color: red;">*Applicable only if you have employees*</p>
            
            <div v-if="!dialogVisible6">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess13"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded13" class="step-form__title">
            </div>

            <h3 style="padding-bottom:38px;color: #E06D21;font-family: 'Open Sans', sans-serif;font-weight: 700;font-size: 24px;line-height: 24px;text-align: center;" class="step-form__title">
              7. Form 1040 Schedule C</h3>
            <div v-if="!dialogVisible7">
              <el-upload
                
                class="avatar-uploader"
                action="/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht"
                :data="{tokenId: this.userInfo.token}"
                accept="*.*"
                :show-file-list="false"
                :on-success="handleAvatarSuccess14"
                :before-upload="beforeAvatarUpload"
                :on-progress="openFullScreen"
              >
                <i class="el-icon-plus avatar-uploader-icon">
                  <span style="margin-left: 10px;">Choose File</span>
                </i>
              </el-upload>
            </div>
            <div id="uploaded14" class="step-form__title">
            </div>
          </div>

          <div class="text-center">
            <el-button
              type="primary"
              :loading="isLoading"
              class="personal-center-form__submit"
              @click="submitForm"
            >submit</el-button>
          </div>
          <!-- <div class="step-form__btn-container">
            <el-button
              type="primary"
              class="rounded-pill bluebg px-5"
              style="float: left;"
              @click="this.window.location.href='/personalCenter'"
            >Back</el-button>

            <el-button
              type="primary"
              :loading="isLoading"
              class="rounded-pill bluebg px-5"
              style="float: right;"
              @click="goNext"
            >Next</el-button>
          </div> -->
          <br />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import _ from "lodash";
import moment from "moment";
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";
import "webuploader/css/webuploader.css";
import jq from "jquery";
import Webuploader from "webuploader";
import { Loading } from "element-ui";
import api from "../../vuex/api/index";
import MultipleUploads from './../applyLoan/MultipleUploads.vue'
import axios from 'axios';

export default {
  data() {
    return {
      isLoading: false,
      progress: 0,
      isShowProgress: false,
      screenHeight: document.body.clientHeight,
      isAccord: false,
      uploader: null,
      fileTypeId: "",
      isSaving: false,
      filePreview: {
        show: false,
        src: ""
      },
      dialogImageUrl: "",
      dialogImageUrl2: "",
      dialogImageUrl3: "",
      dialogImageUrl4: "",
      dialogImageUrl5: "",
      dialogImageUrl6: "",
      dialogImageUrl7: "",
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      dialogVisible7: false,
      imageUrl: "",
      imageUrl2: "",
      fullscreenLoading: false,
      downPaymentOrNot: [
        {
          value: true,
          text: 'Yes'
        },
        {
          value: false,
          text: 'No'
        }
      ],
      reasonsForEquipment: [
        { value: 'Business Growth', text: 'Business Growth' },
        { value: 'Starting New Business', text: 'Starting New Business' },
        { value: 'Refinancing', text: 'Refinancing' },
        { value: 'Replacement', text: 'Replacement' }
      ],
      equipmentTypes: [
        { value: 'Agriculture', text: 'Agriculture' },
        { value: 'Air Transportation', text: 'Air Transportation' },
        { value: 'Automotive', text: 'Automotive' },
        { value: 'Building Automation', text: 'Building Automation' },
        { value: 'Commercial', text: 'Commercial' },
        { value: 'Construction', text: 'Construction' },
        { value: 'Fitness & Spa', text: 'Fitness & Spa' },
        { value: 'Food Service', text: 'Food Service' },
        { value: 'Intermodal', text: 'Intermodal' },
        { value: 'Landscaping', text: 'Landscaping' },
        { value: 'Logging', text: 'Logging' },
        { value: 'Manufacturing', text: 'Manufacturing' },
        { value: 'Marine Transportation', text: 'Marine Transportation' },
        { value: 'Material Handling', text: 'Material Handling' },
        { value: 'Medical', text: 'Medical' },
        { value: 'Packaging', text: 'Packaging' },
        { value: 'Printing', text: 'Printing' },
        { value: 'Rail Transportation', text: 'Rail Transportation' },
        { value: 'Software', text: 'Software' },
        { value: 'Technology - A/V', text: 'Technology - A/V' },
        { value: 'Technology - Commercial', text: 'Technology - Commercial' },
        {
          value: 'Technology - Infrastructure',
          text: 'Technology - Infrastructure'
        },
        { value: 'Trailer - OTR', text: 'Trailer - OTR' },
        { value: 'Trailer - Vocational', text: 'Trailer - Vocational' },
        { value: 'Truck - OTR', text: 'Truck - OTR' },
        { value: 'Truck - Vocational', text: 'Truck - Vocational' },
        { value: 'XX Accessories', text: 'XX Accessories' }
      ],
      status: [
        {
          value: "New",
          text: "New"
        },
        {
          value: "Used",
          text: "Used"
        }
      ],
      stateS: [],
      bankStatement: "",
      paymentStatement: "",
      payableAging: "",
      operatingAgreement: "",
      purchaseOrder: "",
      receivableAging: "",
      backupDocument: "",
      frontAppliedProductId: localStorage.getItem('$appliedProductId'),
      uploadForm: {
        vendorName: "",
        vendorPhone: "",
        vendorAddress: "",
        vendorCity: "",
        vendorState: "",
        vendorZipCode: "",
        equipmentDesc: "",
        equipmentAmount: "",
        equipmentStatus: "",
        wantDownPayment: null,
        reasonsForEquipment: "",
        averageMonthlyBilling: "",
        desiredFactoringAmount: "",
        averageInvoiceSize: "",
        largestInvoice: "",
        smallestInvoice: "",
        anyBillInProgress: false,
        anySalesBillHold: false,
        customerBusinessName1: "",
        customerEmail1: "",
        customerAddress1: "",
        customerPhone1: "",
        customerFax1: "",
        customerWebsite1: "",
        customerPaymentTerms1: "",
        customerCurrentBalance1: "",
        customerBusinessName2: "",
        customerEmail2: "",
        customerAddress2: "",
        customerPhone2: "",
        customerFax2: "",
        customerWebsite2: "",
        customerPaymentTerms2: "",
        customerCurrentBalance2: "",
        customerBusinessName3: "",
        customerEmail3: "",
        customerAddress3: "",
        customerPhone3: "",
        customerFax3: "",
        customerWebsite3: "",
        customerPaymentTerms3: "",
        customerCurrentBalance3: "",
        customerBusinessName4: "",
        customerEmail4: "",
        customerAddress4: "",
        customerPhone4: "",
        customerFax4: "",
        customerWebsite4: "",
        customerPaymentTerms4: "",
        customerCurrentBalance4: "",
        customerBusinessName5: "",
        customerEmail5: "",
        customerAddress5: "",
        customerPhone5: "",
        customerFax5: "",
        customerWebsite5: "",
        customerPaymentTerms5: "",
        customerCurrentBalance5: "",
        anyOutstandingLoans: false,
        ifReceivablesAsCollateral: false,
        nameOfFinancialInstitution: "",
        loanAmountAndTerms: "",
        ifCurrentTaxesPaid: false,
        federalTaxesOwed: "",
        stateTaxesOwed: "",
        anyLiensPlaced: false,
        anyPaymentPlan: false,
        monthlyPayment: "",
        anyLawsuit: false,
        companyAttorney: "",
        companyAttorneyPhone: "",
        companyAccountant: "",
        companyAccountantPhone: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      ajaxBaseUrl: types.GET_AJAX_BASE_URL,
      imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
      userInfo: types.GET_USER,
      fileTypeList: types.GET_UPLOAD_FILE_TYPE_DATA,
      fileList: types.GET_UPLOAD_FILE_DATA
    })
  },
  methods: {
    formatData(data) {
      var arr = [];
      for (var key in data) {
        var obj = {};
        obj.value = data[key];
        obj.text = key;
        arr.push(obj);
      }
      return arr;
    },
    getMgxyDictionary() {
      var _this = this;
      api.mgxyDictionary().then(res => {
        _this.stateS = _this.formatData(res.data.result[0]);
        // _this.titleData = _this.formatData(res.data.result[7]);
        // _this.mastateS = _this.formatData(res.data.result[6]);
      });
    },
    submitForm() {
      // if (this.bankStatement != "" && this.paymentStatement != "") {
        if(this.uploadForm.wantDownPayment == null) {
          return this.setFailMessage({
              show: true,
              content: "Do you want to pay a down payment? Please select Yes or No"
            });
        }

        this.isLoading = true;

        var postData = {
          tokenId: this.userInfo.token,
          customerId: this.userInfo.crmCustomerId,
          //frontApplyId: this.$route.params.id,

          vendorName: this.uploadForm.vendorName || '',
          vendorPhone: this.uploadForm.vendorPhone || '',
          vendorAddress: this.uploadForm.vendorAddress || '',
          vendorCity: this.uploadForm.vendorCity || '',
          vendorState: this.uploadForm.vendorState || '',
          vendorZipCode: this.uploadForm.vendorZipCode || '',
          equipmentAmount: this.uploadForm.equipmentAmount || '',
          equipmentStatus: this.uploadForm.equipmentStatus || '',
          wantDownPayment: this.uploadForm.wantDownPayment,
          reasonForEquipment: this.uploadForm.reasonForEquipment || '',
          equipmentType: this.uploadForm.equipmentType || '',
          equipmentDesc: this.uploadForm.equipmentDesc || '',
          bankStatement: this.bankStatement,
          paymentStatement: this.paymentStatement,

          averageMonthlyBilling: this.uploadForm.averageMonthlyBilling || '',
          desiredFactoringAmount: this.uploadForm.desiredFactoringAmount || '',
          averageInvoiceSize: this.uploadForm.averageInvoiceSize || '',
          largestInvoice: this.uploadForm.largestInvoice || '',
          smallestInvoice: this.uploadForm.smallestInvoice || '',
          anyBillInProgress: this.uploadForm.anyBillInProgress,
          anySalesBillHold: this.uploadForm.anySalesBillHold,
          customerBusinessName1: this.uploadForm.customerBusinessName1 || '',
          customerEmail1: this.uploadForm.customerEmail1 || '',
          customerAddress1: this.uploadForm.customerAddress1 || '',
          customerPhone1: this.uploadForm.customerPhone1 || '',
          customerFax1: this.uploadForm.customerFax1 || '',
          customerWebsite1: this.uploadForm.customerWebsite1 || '',
          customerPaymentTerms1: this.uploadForm.customerPaymentTerms1 || '',
          customerCurrentBalance1: this.uploadForm.customerCurrentBalance1 || '',
          customerBusinessName2: this.uploadForm.customerBusinessName2 || '',
          customerEmail2: this.uploadForm.customerEmail2 || '',
          customerAddress2: this.uploadForm.customerAddress2 || '',
          customerPhone2: this.uploadForm.customerPhone2 || '',
          customerFax2: this.uploadForm.customerFax2 || '',
          customerWebsite2: this.uploadForm.customerWebsite2 || '',
          customerPaymentTerms2: this.uploadForm.customerPaymentTerms2 || '',
          customerCurrentBalance2: this.uploadForm.customerCurrentBalance2 || '',
          customerBusinessName3: this.uploadForm.customerBusinessName3 || '',
          customerEmail3: this.uploadForm.customerEmail3 || '',
          customerAddress3: this.uploadForm.customerAddress3 || '',
          customerPhone3: this.uploadForm.customerPhone3 || '',
          customerFax3: this.uploadForm.customerFax3 || '',
          customerWebsite3: this.uploadForm.customerWebsite3 || '',
          customerPaymentTerms3: this.uploadForm.customerPaymentTerms3 || '',
          customerCurrentBalance3: this.uploadForm.customerCurrentBalance3 || '',
          customerBusinessName4: this.uploadForm.customerBusinessName4 || '',
          customerEmail4: this.uploadForm.customerEmail4 || '',
          customerAddress4: this.uploadForm.customerAddress4 || '',
          customerPhone4: this.uploadForm.customerPhone4 || '',
          customerFax4: this.uploadForm.customerFax4 || '',
          customerWebsite4: this.uploadForm.customerWebsite4 || '',
          customerPaymentTerms4: this.uploadForm.customerPaymentTerms4 || '',
          customerCurrentBalance4: this.uploadForm.customerCurrentBalance4 || '',
          customerBusinessName5: this.uploadForm.customerBusinessName5 || '',
          customerEmail5: this.uploadForm.customerEmail5 || '',
          customerAddress5: this.uploadForm.customerAddress5 || '',
          customerPhone5: this.uploadForm.customerPhone5 || '',
          customerFax5: this.uploadForm.customerFax5 || '',
          customerWebsite5: this.uploadForm.customerWebsite5 || '',
          customerPaymentTerms5: this.uploadForm.customerPaymentTerms5 || '',
          customerCurrentBalance5: this.uploadForm.customerCurrentBalance5 || '',
          anyOutstandingLoans: this.uploadForm.anyOutstandingLoans,
          ifReceivablesAsCollateral: this.uploadForm.ifReceivablesAsCollateral,
          nameOfFinancialInstitution: this.uploadForm.nameOfFinancialInstitution || '',
          loanAmountAndTerms: this.uploadForm.loanAmountAndTerms || '',
          ifCurrentTaxesPaid: this.uploadForm.ifCurrentTaxesPaid,
          federalTaxesOwed: this.uploadForm.federalTaxesOwed || '',
          stateTaxesOwed: this.uploadForm.stateTaxesOwed || '',
          anyLiensPlaced: this.uploadForm.anyLiensPlaced,
          anyPaymentPlan: this.uploadForm.anyPaymentPlan,
          monthlyPayment: this.uploadForm.monthlyPayment || '',
          anyLawsuit: this.uploadForm.anyLawsuit,
          companyAttorney: this.uploadForm.companyAttorney || '',
          companyAttorneyPhone: this.uploadForm.companyAttorneyPhone || '',
          companyAccountant: this.uploadForm.companyAccountant || '',
          companyAccountantPhone: this.uploadForm.companyAccountantPhone || '',
          payableAging: this.payableAging,
          operatingAgreement: this.operatingAgreement,
          purchaseOrder: this.purchaseOrder,
          receivableAging: this.receivableAging,
          backupDocument: this.backupDocument
        };

        console.log("postData", postData);

        api
          .postForm("/mobile/item/loanItemFrontApply/updateUpload.ht", postData)
          .then(res => {
            console.log(res);

            this.setSuccessMessage({
              show: true,
              content: "Submission successful!"
            });
            this.updatePageData();
            this.isLoading = false;
                        
            // this.$router.push({
            //   path: `/personalCenter/myLoan/loanLists`,
            //   query: {
            //     applyLoanId: this.$route.query.applyLoanId,
            //     isEdit: this.$route.query.isEdit
            //   }
            // });
          });
      // } else {
      //   this.$alert("Please provide required supporting documents");
      // }
    },
    sleep(milliseconds) {
      var start = new Date().getTime();
      for (var i = 0; i < 1e7; i++) {
        if (new Date().getTime() - start > milliseconds) {
          break;
        }
      }
    }, 
    handleAvatarSuccess(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
      this.bankStatement = res.result.fileId;
    },
    handleAvatarSuccess2(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded2");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
      this.paymentStatement = res.result.fileId;
    },
    handleAvatarSuccess3(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded3");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
      this.payableAging = res.result.fileId;
    },
    handleAvatarSuccess4(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded4");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
      this.operatingAgreement = res.result.fileId;
    },
    handleAvatarSuccess5(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded5");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
      this.purchaseOrder = res.result.fileId;
    },
    handleAvatarSuccess6(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded6");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
      this.receivableAging = res.result.fileId;
    },
    handleAvatarSuccess7(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded7");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId;
      this.backupDocument = res.result.fileId;
    },
    handleAvatarSuccess8(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded8");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId; 
    },
    handleAvatarSuccess9(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded9");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId; 
    },
    handleAvatarSuccess10(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded10");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId; 
    },
    handleAvatarSuccess11(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded11");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId; 
    },
    handleAvatarSuccess12(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded12");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId; 
    },
    handleAvatarSuccess13(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded13");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId; 
    },
    handleAvatarSuccess14(res, file) {
      Loading.service({ fullscreen: true, lock: true }).close();
      console.log(res.result);
      var uploaded = document.getElementById("uploaded14");
      uploaded.innerHTML = res.result.fileName + " uploaded, file ID: " + res.result.fileId; 
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      return true;
    },
    openFullScreen() {
      Loading.service({ fullscreen: true, lock: true });
    },
    ...mapActions({
      getFileList: types.SET_UPLOAD_FILE_DATA,
      saveFile: types.SAVE_UPLOADED_FILE,
      saveApplyLoanProgress: types.SAVE_APPLY_LOAN_PROGRESS,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE,
      getPersonalInitData: types.GET_PERSONAL_INIT_DATA
    }),
    ...mapMutations({
      saveCurrentUploadFiles: types.SAVE_CURRENT_UPLOAD_FILE,
      deleteFile: types.DELETE_UPLOADED_FILE
    }),

    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureCardPreview2(file) {
      this.dialogImageUrl2 = file.url;
      this.dialogVisible2 = true;
    },
    calculateFileSize(bytes) {
      if (bytes > 1024 * 1024) {
        return `${(bytes / (1024 * 1024)).toFixed(2)}MB`;
      } else if (bytes > 1024) {
        return `${(bytes / 1024).toFixed(2)}KB`;
      } else {
        return `${bytes}B`;
      }
    },
    deleteUploadedFile(typeId, file) {
      this.uploader.removeFile(file.uploaderId, true);
      this.deleteFile({
        typeId,
        file
      });
    },
    showPreviewImage(fileId, isImage) {
      const src = `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${fileId}&tokenId=${this.userInfo.token}`;
      if (isImage) {
        this.filePreview = {
          show: true,
          src
        };
      } else {
        window.open(`${location.origin}${src}`);
      }
    },
    hidePreviewImage() {
      this.filePreview.show = false;
    },
    renderBR: function() {
      var _this = this;
      function render() {
        var p = BRCore.prototype.options;
        // console.log('pp..');
        //console.log(p)
        document.querySelector("#br_gid").value = p.gid;

        var sec1HTML = "";
        var sec2HTML = "";
        var f = BRCore.inputs._f;
        for (var item in p) {
          //console.log(item,p[item]);
          sec1HTML +=
            '<tr><td class="title">' +
            item +
            "</td><td>" +
            p[item] +
            "</td></tr>";
        }

        for (var item1 in f.tag) {
          //console.log(item1,f.tag[item1]);
          sec2HTML +=
            '<tr><td class="title">' +
            item1 +
            "</td><td>" +
            decodeURIComponent(f.tag[item1]) +
            "</td></tr>";
        }

        document.getElementById("sec1").innerHTML =
          '<table class="tb1" border="1">' + sec1HTML + "</table>";
        document.getElementById("sec2").innerHTML =
          '<table class="tb1" border="1">' + sec2HTML + "</table>";

        document.getElementById("gid").innerHTML = BRCore.prototype.options.gid;
      }

      isReady(function() {
        render();
      });

      function isReady(fn) {
        var timer = setInterval(function() {
          try {
            if (BRCore.prototype.options.gid && BRCore.inputs._f.tag.bt) {
              clearInterval(timer);
              timer = null;
              fn && fn();
            }
          } catch (e) {}
        }, 100);
      }
/*
      var win = window,
        doc = document,
        br = (win["BAIRONG"] = win["BAIRONG"] || {}),
        s = doc.createElement("script"),
        url = "https://static.100credit.com/ifae/js/braf-v3.min.js";
      s.type = "text/javascript";
      s.charset = "utf-8";
      s.src = url;
      br.client_id = "3002052"; //正式上线用apiCode
*/
      //============= 可选 =============

      doc.getElementsByTagName("head")[0].appendChild(s);
      br.BAIRONG_INFO = {
        app: "antifraud",
        event: "login" //REGISTRATION：register、借款：lend、登录：login、提现：cash
      };
      window.GetSwiftNumber = function(data) {
        //获取流水号的回调
        console.log(data); //获取整个response
        console.log(data.code); //获取返回code码
        console.log(data.response.event); // 获取事件类型
        console.log(data.response.af_swift_number); //获取设备请求流水号

        if (win.isGetSwiftNumberExec) {
          //return;
        }
        win.isGetSwiftNumberExec = true;

        try {
          var af_swift_number = data.response.af_swift_number;
        } catch (e) {
          var af_swift_number = "null";
        }
        document.getElementById("console").innerHTML = af_swift_number;
      };

      window.loginHandler = function() {
        document.getElementById("test").click();
      };
    },
    goBack() {
      this.$router.push({
        path: `/applyLoan/${this.$route.params.id}/sbl4`,
        query: {
          applyLoanId: this.$route.query.applyLoanId,
          selectedBankcardId: this.selectedBankcardId,
          isEdit: true
        }
      });

      /*this.uploader.reset()
        this.saveApplyLoanProgress({
          router: this.$router,
          token: this.userInfo.token,
          id: this.$route.query.applyLoanId,
          bankAccountId: this.$route.query.selectedBankcardId,
          step: 3
        }).then((res) => {
          if (Number(res.data.code) === 0) {
            if (`${this.$route.query.isEdit}` === 'true') {
              this.$router.push({
                path: `/applyLoan/${this.$route.params.id}/sbl3`,
                query: {
                  applyLoanId: this.$route.query.applyLoanId,
                  selectedBankcardId: this.selectedBankcardId,
                  isEdit: true
                }
              })
            } else {
              this.$router.go(-1)
            }
          }
        })*/
    },
    // goNext() {
    //     this.$router.push({
    //       path: `/applyLoan/${this.$route.params.id}/sbl2`,
    //       query: {
    //         applyLoanId: this.$route.query.applyLoanId,
    //         isEdit: this.$route.query.isEdit
    //       }
    //     });
    // },
    changeFileType(fileTypeId) {
      this.fileTypeId = fileTypeId;
    },
    uploadBeforeSend(obj, data) {
      data.fileTypeId = this.fileTypeId;
      data.tokenId = this.userInfo.token;
      this.isShowProgress = true;
    },
    uploadProgress(file, percent) {
      const _this = this;
      //        const timer = setInterval(() => {
      //          if (_this.progress >= percent * 100) {
      //            clearInterval(timer)
      //            _this.isShowProgress = false
      //          }
      //          _this.progress ++
      //        }, 25)
      _this.progress = percent * 100;
      //        if (_this.progress >= percent * 100) _this.isShowProgress = false
    },
    uploadSuccess(file, res) {
      const arr = _.split(res, ":");
      this.saveCurrentUploadFiles({
        typeId: Number(arr[2].replace("fileTypeId=", "")),
        file: {
          fileId: Number(arr[0].replace("sysFile=", "")),
          date: moment(file.lastModified).format("YYYY-MM-DD hh:mm"),
          fileName: file.name,
          size: this.calculateFileSize(file.size),
          hasSaved: false,
          uploaderId: file.id, // 上传文件id
          extension: file.name.substr(file.name.lastIndexOf(".") + 1),
          isImag: /image/g.test(file.type)
        }
      });
      this.progress = 0;
      this.isShowProgress = false;
    },
    uploadError(file, reason) {
      if (reason === "http") {
        this.setFailMessage({
          show: true,
          content: "Upload error, plese try to use latest version of Chrome！"
        });
      }
      this.uploader.removeFile(file, true);
      this.progress = 0;
      this.isShowProgress = false;
    },
    uploadValidata(type) {
      switch (type) {
        case "F_DUPLICATE": // 是否重复
          this.setFailMessage({
            show: true,
            content: "This file already uploaded！"
          });
          break;
        case "Q_TYPE_DENIED": // 文件类型是否满足
          this.setFailMessage({
            show: true,
            content:
              "File extension need to be .jpg，jpeg,.png, .gif，.bmp，.gif，.doc，docx, .rar，.zip，.7z"
          });
          break;
        case "Q_EXCEED_SIZE_LIMIT": // 文件大小是否超出
          this.setFailMessage({
            show: true,
            content: "File size over 10M"
          });
          break;
      }
    },
    createWebUploader() {
      this.uploader = Webuploader.create({
        auto: true, // 自动上传
        swf: "./static/Uploader.swf",
        server: `${this.ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/saveFile.ht`,
        pick: {
          id: ".picker",
          multiple: true
        },
        chunked: true,
        duplicate: false, // 去重
        fileSizeLimit: 1024 * 1024 * 10,
        accept: {
          title: "*",
          extensions: "gif,jpg,jpeg,bmp,png,doc,docx,pdf,rar,zip",
          mimeTypes:
            "image/*,application/msword,application/pdf,application/x-rar-compressed,application/x-zip-compressed,application/x-7z-compressed"
        }
      });
      this.uploader.on("uploadBeforeSend", this.uploadBeforeSend);
      this.uploader.on("uploadProgress", this.uploadProgress);
      this.uploader.on("uploadSuccess", this.uploadSuccess);
      this.uploader.on("uploadError", this.uploadError);
      this.uploader.on("error", this.uploadValidata);
    },
    updatePageData() {
      this.getPersonalInitData({
        token: this.userInfo.token,
        customerId: this.userInfo.crmCustomerId
      }).then(res => {
        console.log(res);
        if (Number(res.data.code) === 0) {
          const data = res.data.result;
          this.uploadForm = {
            vendorName: data.employer.vendorName,
            vendorPhone: data.employer.vendorPhone,
            vendorAddress: data.employer.vendorAddress,
            vendorCity: data.employer.vendorCity,
            vendorState: data.employer.vendorState,
            vendorZipCode: data.employer.vendorZipCode,
            equipmentAmount: data.employer.equipmentAmount,
            equipmentStatus: data.employer.equipmentStatus,
            wantDownPayment: data.employer.wantDownPayment,
            reasonForEquipment: data.employer.reasonForEquipment,
            equipmentDesc: data.employer.equipmentDesc,
            equipmentType: data.employer.equipmentType,
            bankStatement: data.employer.bankStatement,
            paymentStatement: data.employer.paymentStatement,

            averageMonthlyBilling: data.employer.averageMonthlyBilling,
            desiredFactoringAmount: data.employer.desiredFactoringAmount,
            averageInvoiceSize: data.employer.averageInvoiceSize,
            largestInvoice: data.employer.largestInvoice,
            smallestInvoice: data.employer.smallestInvoice,
            anyBillInProgress: data.employer.anyBillInProgress,
            anySalesBillHold: data.employer.anySalesBillHold,
            customerBusinessName1: data.employer.customerBusinessName1,
            customerEmail1: data.employer.customerEmail1,
            customerAddress1: data.employer.customerAddress1,
            customerPhone1: data.employer.customerPhone1,
            customerFax1: data.employer.customerFax1,
            customerWebsite1: data.employer.customerWebsite1,
            customerPaymentTerms1: data.employer.customerPaymentTerms1,
            customerCurrentBalance1: data.employer.customerCurrentBalance1,
            customerBusinessName2: data.employer.customerBusinessName2,
            customerEmail2: data.employer.customerEmail2,
            customerAddress2: data.employer.customerAddress2,
            customerPhone2: data.employer.customerPhone2,
            customerFax2: data.employer.customerFax2,
            customerWebsite2: data.employer.customerWebsite2,
            customerPaymentTerms2: data.employer.customerPaymentTerms2,
            customerCurrentBalance2: data.employer.customerCurrentBalance2,
            customerBusinessName3: data.employer.customerBusinessName3,
            customerEmail3: data.employer.customerEmail3,
            customerAddress3: data.employer.customerAddress3,
            customerPhone3: data.employer.customerPhone3,
            customerFax3: data.employer.customerFax3,
            customerWebsite3: data.employer.customerWebsite3,
            customerPaymentTerms3: data.employer.customerPaymentTerms3,
            customerCurrentBalance3: data.employer.customerCurrentBalance3,
            customerBusinessName4: data.employer.customerBusinessName4,
            customerEmail4: data.employer.customerEmail4,
            customerAddress4: data.employer.customerAddress4,
            customerPhone4: data.employer.customerPhone4,
            customerFax4: data.employer.customerFax4,
            customerWebsite4: data.employer.customerWebsite4,
            customerPaymentTerms4: data.employer.customerPaymentTerms4,
            customerCurrentBalance4: data.employer.customerCurrentBalance4,
            customerBusinessName5: data.employer.customerBusinessName5,
            customerEmail5: data.employer.customerEmail5,
            customerAddress5: data.employer.customerAddress5,
            customerPhone5: data.employer.customerPhone5,
            customerFax5: data.employer.customerFax5,
            customerWebsite5: data.employer.customerWebsite5,
            customerPaymentTerms5: data.employer.customerPaymentTerms5,
            customerCurrentBalance5: data.employer.customerCurrentBalance5,
            anyOutstandingLoans: data.employer.anyOutstandingLoans,
            ifReceivablesAsCollateral: data.employer.ifReceivablesAsCollateral,
            nameOfFinancialInstitution: data.employer.nameOfFinancialInstitution,
            loanAmountAndTerms: data.employer.loanAmountAndTerms,
            ifCurrentTaxesPaid: data.employer.ifCurrentTaxesPaid,
            federalTaxesOwed: data.employer.federalTaxesOwed,
            stateTaxesOwed: data.employer.stateTaxesOwed,
            anyLiensPlaced: data.employer.anyLiensPlaced,
            anyPaymentPlan: data.employer.anyPaymentPlan,
            monthlyPayment: data.employer.monthlyPayment,
            anyLawsuit: data.employer.anyLawsuit,
            companyAttorney: data.employer.companyAttorney,
            companyAttorneyPhone: data.employer.companyAttorneyPhone,
            companyAccountant: data.employer.companyAccountant,
            companyAccountantPhone: data.employer.companyAccountantPhone,
            payableAging: data.employer.payableAging,
            operatingAgreement: data.employer.operatingAgreement,
            purchaseOrder: data.employer.purchaseOrder,
            receivableAging: data.employer.receivableAging,
            backupDocument: data.employer.backupDocument
          };
        }
      });
    }
  },

  mounted() {
    jq();
    const _this = this;
    this.getMgxyDictionary();
    // localStorage.setItem("$appliedProductId", 10000057880003);
    console.log(this.frontAppliedProductId);
    this.updatePageData();
  }
};
</script>
<style lang="scss">
@import "../../styles/fileUpload";

body {
  overflow: auto !important;
}

.el-upload .el-upload--picture-card {
  text-align: center;
}

.step4-form .step-form__title {
  margin-bottom: 36px;
}

.file-preview-modal {
  .dialog__footer__confirm-btn {
    background-color: $orange;
  }
}
.file-preview-modal__body {
  overflow: auto;
}

.progressDialog {
  .el-dialog__header {
    display: none;
  }

  .dialog__close {
    display: none;
  }
}
.upload_progress {
  width: 300px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// UpdateEquipment.vue?05833ea9